// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__On8Rq","content":"style_content__T50j3","modal-title":"style_modal-title__tRGs2","link":"style_link__P+PyZ"};